import { render, staticRenderFns } from "./AnswerCkeditor.vue?vue&type=template&id=7867f382&scoped=true"
import script from "./AnswerCkeditor.vue?vue&type=script&lang=js"
export * from "./AnswerCkeditor.vue?vue&type=script&lang=js"
import style0 from "./AnswerCkeditor.vue?vue&type=style&index=0&id=7867f382&prod&lang=less"
import style1 from "./AnswerCkeditor.vue?vue&type=style&index=1&id=7867f382&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7867f382",
  null
  
)

export default component.exports